<template name="newInvisit">
  <div class="newInvisitContent scrolled">
    <div>{{ ticketId ? this.$t('EditInvitation') : this.$t('NewInvitation') }}<i class="iconfont icon-close" @click="closeList"></i></div>
    <div class="new-invisit-content" ref="content" v-on:scroll.passive="onScroll">
       <div>
         <div class="new-invite-row invisitMessage">
            <div class="new-invite-title">{{$t('InvitationInfo')}}</div>
            <div>
              <div class="row" :class="{'form-error': errorMsgStartDate}">
                <div class="col-3">
                  {{$t('startDate')}}
                </div>
                <div class="col-9 invisitTime">
                  <dateTimePicker
                    :isStartDate="true"
                    v-model="startDate"
                    :placeholder="$t('chooseDate')"
                    @change="handleDateChange"
                  ></dateTimePicker>
                </div>
              </div>
              <label class="error-msg"  v-show="errorMsgStartDate">{{errorStartDate}}</label>
              <div class="row" :class="{'form-error': errorMsgEndDate}">
                <div class="col-3">
                  {{$t('endDate')}}
                </div>
                <div class="col-9 invisitTime">
                  <dateTimePicker
                    :isEndDate="true"
                    v-model="endDate"
                    :placeholder="$t('chooseEndDate')"
                    @change="handleDateChange"
                  ></dateTimePicker>
                </div>
              </div>
              <label class="error-msg"  v-show="errorMsgEndDate">{{errorEndDate}}</label>
              <div class="row" :class="{'form-error': errorMsgTypeSelect}" @click="(inviteInfo && inviteInfo.hasMaterial) ? isTipsModalShown = true : isTipsModalShon = false">
                <div class="col-3">
                  {{$t('visitType')}}
                </div>
                <div class="col-9 invisitArea typeList" >
                  <!-- <select @change="handleTypeChange" v-model="typeId" :class="{ 'un-selected': typeId === -1 }" :disabled="inviteInfo && inviteInfo.hasMaterial">
                    <option :value="-1">{{$t('SelectType')}}</option>
                    <option v-for="type in typeList" :value="type.id" :key="type.id">
                      {{ type.typeNlame }}
                    </option>
                  </select> -->
                  <div @click="selectTypeShowHide">
                    <span>{{selectTypeShowTxt}}</span><i class="iconfont icon-right"></i>
                  </div>
                  <div><input type="hidden" v-model="typeId" name=""></div>
                  <ul v-show="selectTypeShow">
                    <li v-for="type in typeList" :key="type.id" @click="handleTypeChange(type.id, type.typeName)">
                      {{ type.typeName }}
                    </li>
                  </ul>
                </div>
              </div>
              <label class="error-msg"  v-show="errorMsgTypeSelect">{{$t('SelectType')}}</label>
              <div class="row" :class="{'form-error': errorMsgAreaSelect}" @click="(inviteInfo && inviteInfo.hasMaterial) ? isTipsModalShown = true : isTipsModalShon = false">
                <div class="col-3">
                  {{$t('visitArea')}}
                </div>
                <div class="col-9 invisitArea typeList areaList" @click="checkTypeisNull">
                 <!-- <select @change="handleAreaChange(null, $event)" :disabled="isAreaDisabled || (inviteInfo && inviteInfo.hasMaterial)" v-model="areaId" :class="{ 'un-selected': areaId === -1 }">
                  <option :value="-1"> {{$t('SelectVisitArea')}}</option>
                   <option v-for="area in areaList" :value="area.id" :key="area.id" >
                     {{ area.areaName }}
                   </option>
                 </select> -->

                 <div>
                   <span>{{selectAreaShowTxt}}</span><i class="iconfont icon-right"></i>
                 </div>
                 <div><input type="hidden" v-model="areaId" name=""></div>
                 <ul v-show="selectAreaShow">
                   <li v-for="area in areaList" :key="area.id" @click="handleAreaChange(null, area.id, area.areaName)">
                     {{ area.areaName }}
                   </li>
                 </ul>
                </div>
              </div>
              <label class="error-msg"  v-show="errorMsgAreaSelect"> {{$t('SelectVisitArea')}}</label>
            </div>
         </div>
         <div class="new-invite-row add-detail-info" v-show="typeId !== -1 && areaId !== -1">
           <div class="new-invite-title">{{$t('DetailedVisitInfo')}}
             <span v-if="!(isSpecialArea || isSpecialType)" class="optional">
               {{$t('optional')}}
             </span>
           </div>
           <div class="detail">
            <div>
              <div>
                {{$t('accessSubdivisionArea')}}
              </div>
              <div class="textarea-detail">
                <textarea :placeholder="$t('fillDetailsHere')" rows="2" v-model="areaDetail" @input="checkDetail"></textarea>
              </div>
            </div>
            <div>
              <div>
                {{$t('visitPurpose')}}
              </div>
              <div class="textarea-detail">
                <textarea :placeholder="$t('fillDetailsHere')" rows="2" v-model="purposeDetail" @input="checkDetail"></textarea>
              </div>
            </div>
           </div>
           <label class="error-msg"  v-show="errorMsgReason && (isSpecialType || isSpecialArea)">{{$t('InputInfo')}}</label>
        </div>
        <div class="new-invite-row main-invisit bottlingBox" v-if="!isCoke && typeId !== -1 && areaId !== -1 && bottlers.length !== 0 ">
           <div class="new-invite-title">{{$t('PrimaryInfo')}}</div>
           <div class="row bottlingSelect" :class="{'form-error': errorMsgBottlerSelect}">
             <div class="col-3">
               {{$t('bottler')}}
             </div>
             <div class="col-9 invisitBottling typeList areaList" @click="checkAreaisNull">
              <div>
                <span>{{selectBottlingShowTxt}}</span><i class="iconfont icon-right"></i>
              </div>
              <div><input type="hidden" v-model="bottlerId" name=""></div>
              <ul v-show="selectBottlerShow">
                <li v-for="bottler in bottlers" :key="bottler.bottlerId" @click="handleBottlerChange(null, bottler.bottlerId, bottler.bottlerName)">
                  {{ bottler.bottlerName }}
                </li>
              </ul>
             </div>
           </div>
           <label class="error-msg"  v-show="errorMsgBottlerSelect"> {{$t('SelectVisitArea')}}</label>
           <div class="row name-select" :class="{'form-error': errorMsgName}">
              <div class="col-3">
                {{$t('UserInfo')}}
              </div>
              <div class="col-9">
                <input :placeholder="$t('SelectPrimaryVisitor')"
                  :value="primaryVisitor.userName ? `${primaryVisitor.userName} ${primaryVisitor.contact}` : ''"
                  class="select-ko" type="text" @click="checkIfCanAddKO">
                  <i class="iconfont icon-right"></i>
              </div>
            </div>
            <label class="error-msg" v-show="errorMsgName">
              {{ $t('SelectPrimaryVisitor') }}
              </label>
           <div>
             <primaryVisitorExtraField
               :hasMaterialsToFill="hasMaterialsToFill"
               :showPrimaryVisitorExtraField="showPrimaryVisitorExtraField"
               @togglePrimaryVisitorExtraField="handleTogglePrimaryVisitorExtraField">
               <addVisitorDetail
                 :isKOSystem="true"
                 :isPrimaryVisitor="true"
                 :showVisitorDetail="showPrimaryVisitorExtraField"
                 :materials="primaryVisitor.materials"
                 @answer="handleAnswer"
                 @deleteImg="handleDeleteImg"
                 @deleteAnnex="handleDeleteAnnex"
                 @saveCurrent="handleSaveCurrent"
                 @clearCurrent="handleClearCurrent"
                 @loadHistory="handleLoadHistory(true)"
                 @loadCompanyHistory="handleLoadCompanyHistory"
               >
               </addVisitorDetail>
             </primaryVisitorExtraField>
           </div>
        </div >
         <div class="new-invite-row main-invisit" v-if="!isCoke && typeId !== -1 && areaId !== -1 && bottlers.length == 0 ">
            <div class="new-invite-title">{{$t('PrimaryInfo')}}</div>
            <div>
              <div class="row" :class="{'form-error': errorMsgName}">
                <div class="col-4">
                  {{$t('name')}}
                </div>
                <div class="col-8">
                  <input :placeholder="$t('InputName')" type="text" name="" v-model.trim="primaryVisitor.userName" @blur="checkName">
                </div>
              </div>
              <label class="error-msg"  v-show="errorMsgName">{{$t('PleaseName')}}</label>
              <div class="row" :class="{'form-error': !validContact}">
                <div class="col-4">
                  <label @click="showContatSelect = true" class="control-label">
                    {{ primaryVisitor.pickedContact }}
                    <i class="iconfont icon-down"></i>
                  </label>

                  <transition name="fade">
                    <div class="contact-select" v-show="showContatSelect">
                      <div class="inner">
                        <div class="form-group">
                          <input type="radio" id="tel" :value="$t('mobile')" v-model="primaryVisitor.pickedContact">
                          <label for="tel" @click="hideContactSelect">{{$t('mobile')}}</label>
                        </div>
                        <div class="form-group">
                          <input type="radio" id="mail" :value="$t('email')" v-model="primaryVisitor.pickedContact">
                          <label for="mail" @click="hideContactSelect">{{$t('email')}}</label>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
                <div class="col-8">
                  <input type="text" name="contact"
                    :placeholder=" this.$t('addVisitor') + ' ' + primaryVisitor.pickedContact"
                    @blur="checkContact"
                    v-model.trim="primaryVisitor.contact">
                </div>
              </div>
              <label class="error-msg" v-show="!validContact">
                {{ !primaryVisitor.contact ? $t('PleaseInput') +  primaryVisitor.pickedContact : $t('inputCorrect') + primaryVisitor.pickedContact }}
              </label>

              <primaryVisitorExtraField
                :hasMaterialsToFill="hasMaterialsToFill"
                :showPrimaryVisitorExtraField="showPrimaryVisitorExtraField"
                @togglePrimaryVisitorExtraField="handleTogglePrimaryVisitorExtraField">
                <addVisitorDetail
                  :isKOSystem="true"
                  :isPrimaryVisitor="true"
                  :showVisitorDetail="showPrimaryVisitorExtraField"
                  :materials="primaryVisitor.materials"
                  @answer="handleAnswer"
                  @deleteImg="handleDeleteImg"
                  @deleteAnnex="handleDeleteAnnex"
                  @saveCurrent="handleSaveCurrent"
                  @clearCurrent="handleClearCurrent"
                  @loadHistory="handleLoadHistory(true)"
                  @loadCompanyHistory="handleLoadCompanyHistory"
                >
                </addVisitorDetail>
              </primaryVisitorExtraField>
            </div>
         </div>
         <div class="new-invite-row" v-show="isCoke && typeId !== -1 && areaId !== -1">
           <addInnerVisitor @koStatus="changeStatus" :innerList="innerList"
           @deleteKO="deleteKO"></addInnerVisitor>
           <label class="error-msg right-padding" v-show="errorMsgInnerVisitor && !innerList.length">{{$t('addIinternalVisitor')}}</label>
         </div>
         <div class="new-invite-row selectCourse-detail">
           <selectCourse @joinCourse="handleJoinCourse" @courseSelect="handleCourseSelect"
           :isJoin="isJoin" :elLessonList="elLessonList"></selectCourse>
           <label class="error-msg right-padding" v-show="errorMsgLesson">{{$t('selectCourseCategory')}}</label>
         </div>

         <div class="new-invite-row visitor-detail-list-row"  v-show="visitorDetailList.length && !showVisitorDetail" id="visitor-detail-list">
           <div class="detail-list-show-up" @click="showOtherVisitor = !showOtherVisitor">
            <div class="row">
              <div class="title col-9">
                {{$t('visitorInfo')}}
              </div>
              <div class="col-3">
                <i class="iconfont" :class="showOtherVisitor ? 'icon-up' : 'icon-down'"></i>
              </div>
            </div>
           </div>
           <div v-if="showOtherVisitor">
            <visitorDetailList
             :isKOSystem="true"
             :visitorDetailList="visitorDetailList"
             :isForKOInnerVisitor="isCoke"
             @editVisitorDetail="handleAddOrEditVisitorDetail"
             v-show="!showVisitorDetail">
            </visitorDetailList>
           </div> 
         </div>
         <div class="new-invite-row" v-show="typeId !== -1 && areaId !== -1" id="add-visitor-detail">
           <addVisitorDetail
            :isKOSystem="true"
            :isForKOInnerVisitor="isCoke"
            :koListItem="innerList"
            :isPrimaryVisitor="false"
            :showVisitorDetail="showVisitorDetail"
            :materials="currentMaterials"
            :currentVisitor="currentVisitor"
            @addVisitorDetail="handleAddOrEditVisitorDetail"
            @answer="handleAnswer"
            @deleteImg="handleDeleteImg"
            @deleteAnnex="handleDeleteAnnex"
            @saveCurrent="handleSaveCurrent"
            @clearCurrent="handleClearCurrent"
            @loadHistory="handleLoadHistory(false)"
            @loadCompanyHistory="handleLoadCompanyHistory"
            @addKOUser="handleAddKOUser"
            >

           </addVisitorDetail>
         </div>
         <div class="new-invite-row">
           <addApproved @koStatus="changeStatus" :approvedList="approvedList"
           @deleteKO="deleteKO"></addApproved>
         </div>
         <div class="new-invite-row">
           <addCopy @koStatus="changeStatus" :copyList="copyList" @deleteKO="deleteKO"></addCopy>
         </div>
         <div class="new-invite-row select-language">
          <div class="row">
            <div class="new-invite-title col-8">{{$t('VisitorPreferenceLanguage')}}</div>
            <div class="col-4 down-language">
              <div @click="languageShow = !languageShow">
                <span>{{preferredLanguageValue}}</span><i class="iconfont icon-right"></i>
                  <input type="hidden" v-model="preferredLanguage">
              </div>
              <ul v-show="languageShow">
                <li @click="changeLanguage(1, $t('setLangCN'))">{{$t('setLangCN')}}</li>
                <li @click="changeLanguage(2, $t('setLangEN'))">{{$t('setLangEN')}}</li>
              </ul>
              <!-- <select v-model="preferredLanguage">
                <option value="1">{{$t('setLangCN')}}</option>
                <option value="2">{{$t('setLangEN')}}</option>
              </select> -->
            </div>
          </div>
         </div>
         <div class="commit-btn" @click="checkData">
           <span>{{$t('submit')}}</span>
         </div>
       </div>
    </div>
    <koList v-show="addKO" @koStatus="changeStatus"></koList>
    <!-- delete added other visitor -->
    <alertModal :isModalShown="isDeleteModalShow" :modalTitle="$t('confirmToDelete')" @cancel="isDeleteModalShow = false" @confirm="deleteVisitor"></alertModal>
    <!-- not editable tips -->
    <alertModal modalType="simple" :isModalShown="isTipsModalShown" :modalTitle="notEditableTips" @cancel="isTipsModalShown = false"></alertModal>
    <!-- confirm commit -->
    <alertModal :isModalShown="isCommit" :modalTitle="isTimeChanged ? timeChangeTips : this.$t('ConfirSubmit')" @cancel="isCommit = false" @confirm="commitData"></alertModal>
    <!-- confirm commited -->
    <alertModal modalType="simple" :isModalShown="isConfirm" :modalTitle="addSucess" @cancel="closeModal"></alertModal>
    <!-- first select type tips -->
    <alertModal modalType="simple" :isModalShown="isSelectTipsModalShown" :modalTitle="notSelectTips" @cancel="isSelectTipsModalShown = false"></alertModal>
    <!-- first select bottler tips -->
    <!-- <alertModal modalType="simple" :isModalShown="isSelectBottlerTipsModalShown" :modalTitle="notSelectAearTips" @cancel="isSelectBottlerTipsModalShown = false"></alertModal>
 -->
    <!-- commit error data -->
    <alertModal modalType="simple" :isModalShown="isRequireModal" :modalTitle="isRequireModalTips" @cancel="isRequireModal = false"></alertModal>
    

    <koPrimaryList v-show="isAddPrimary" :isSingleSelect="true" :koListItem="bottlerRelevancePrimaryVisitors"  @koStatus="handleSelectKO"></koPrimaryList>

    <alertModal
      modalType="simple"
      :isModalShown="isPrimaryVisitorAlertShow"
      :modalTitle="$t('PleaseAddBottler')"
      @cancel="isPrimaryVisitorAlertShow = false"
    >
   </alertModal>
    <alertModal
      modalType="simple"
      :isModalShown="noPrimaryVisitorAlertShow"
      :modalTitle="$t('noValidContact')"
      @cancel="noPrimaryVisitorAlertShow = false"
    >
    </alertModal>

    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">
import selectCourse from '@/components/selectCourse.vue';
import addInnerVisitor from '@/components/addInnerVisitor.vue';
import addCopy from '@/components/addCopy.vue';
import addApproved from '@/components/addApproved.vue';
import primaryVisitorExtraField from '@/components/primaryVisitorExtraField.vue';
import addVisitorDetail from '@/components/addVisitorDetail.vue';
import visitorDetailList from '@/components/visitorDetailList.vue';
import koList from '@/components/koList.vue';
import alertModal from '@/components/alertModal.vue';
import dateTimePicker from '@/components/dateTimePicker.vue';
import koPrimaryList from '@/components/koPrimaryList.vue';
import {
  getVisitorType, getEffectiveAreaList, getELLessonCategoryList, InsertOrUpdate, getMaterialOptions,
  loadHistroyMaterialAnswers, loadHistroyCompanyMaterialAnswers, getBottlerPrimaryVisitors
} from '@/utils/api';
import { checkNested, regExp, scrollErrMsgToView } from '@/utils/utils';
import Materials from '@/utils/materials';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Moment from 'moment';

let materialsInstance = null;

export default {
  name: 'newInvisit',
  components: {
    selectCourse,
    addInnerVisitor,
    addCopy,
    addApproved,
    primaryVisitorExtraField,
    addVisitorDetail,
    visitorDetailList,
    koList,
    Loading,
    alertModal,
    dateTimePicker,
    koPrimaryList,
  },
  data() {
    return {
      isCommit: false,
      modalView: false,
      showAddMore: false,
      pickedContact: this.$t('mobile'),
      showContatSelect: false,
      scrolled: false,
      contact: '',
      validContact: true,
      addKO: false,

      startDate: '',
      endDate: '',
      typeList: [],
      areaList: [],
      typeId: -1,
      areaId: -1,
      bottlerId: -1,
      isSpecialArea: false,
      isSpecialType: false,
      areaDetail: '',
      purposeDetail: '',
      isCoke: false,
      elLessonList: [],
      isJoin: false,
      selectedCourse: [],
      addKOType: '',
      innerList: [],
      approvedList: [],
      copyList: [],

      preferredLanguage: 1,
      errorMsgReason: false,
      errorMsgStartDate: false,
      errorStartDate: this.$t('entered'),
      errorMsgEndDate: false,
      errorEndDate: this.$t('endDateMustBeLater'),
      userName: '',
      errorMsgName: false,
      addSucess: this.$t('SubmittedSuccessfully'),
      isConfirm: false,
      isAreaDisabled: true,
      errorMsgTypeSelect: false,
      errorMsgAreaSelect: false,
      errorMsgLesson: false,
      errorMsgInnerVisitor: false,
      DetailId: '',
      isLoading: false,

      // add visitor detail
      showPrimaryVisitorExtraField: false,
      hasMaterialsToFill: true,
      showVisitorDetail: false,
      isAdd: true,
      idx: -1,
      materials: [],
      currentMaterials: [],
      currentVisitor: {
        id: 0,
        userName: '',
        pickedContact: '',
        contact: '',
        isPrimaryVisitor: false,
        materials: [],
        hasSubmitMaterials: false,
      },
      visitorDetailList: [],

      primaryVisitor: {
        id: 0,
        userName: '',
        pickedContact: this.$t('mobile'),
        contact: '',
        isPrimaryVisitor: true,
        materials: [],
        hasSubmitMaterials: false,
        bottlerId: '',
      },
      isDeleteModalShow: false,

      // edit info
      ticketId: 0,
      isTipsModalShown: false,
      notEditableTips: this.$t('canNotmodified'),
      timeChangeTips: this.$t('needToreApprove'),
      isTimeChanged: false,
      initTime: { startDate: '', endDate: '' },
      selectTypeShow: false,
      selectTypeShowTxt: this.$t('SelectType'),
      selectAreaShow: false,
      selectAreaShowTxt: this.$t('SelectVisitArea'),
      preferredLanguageValue: this.$t('setLangCN'),
      languageShow: false,
      isSelectTipsModalShown: false,
      notSelectTips: this.$t('PleaseChooseVisitType'),
      showOtherVisitor: false,
      isRequireModal: false,
      isRequireModalTips: '',
      isPrimaryVisitorAlertShow: false,
      selectBottlingShowTxt: this.$t('chooseBottler'),
      bottlers: [],
      selectBottlerShow: false,
      isAddPrimary: false,
      bottlerRelevancePrimaryVisitors: [],
      errorMsgBottlerSelect: false,
      noPrimaryVisitorAlertShow: false,
    };
  },
  props: {
    inviteInfo: Object,
  },
  created() {
    // bind init type list
    getVisitorType().then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        this.typeList = res.data.content.model;
        const { id, trackingType, isCoke } = this.typeList[0];
        this.isSpecialType = trackingType === 4; // construction type
        this.isCoke = isCoke;
        this.typeId = -1;
        this.showOtherVisitor = false;
        return getEffectiveAreaList(id);
      }
    })
      .then((res) => {
      // bind init area list
        if (checkNested(res, 'data', 'content', 'model')) {
          this.areaList = res.data.content.model;
          const { areaType } = this.areaList[0];
          this.isSpecialArea = areaType === 2; // special area
          this.areaId = -1;
          return getELLessonCategoryList();
        }
      })
      .then((res) => {
        // bind init EL Lesson list
        if (checkNested(res, 'data', 'content', 'model')) {
          this.elLessonList = res.data.content.model;
        }
      });

  },
  watch: {
    inviteInfo(info) {
       //console.log(info);
      this.ticketId = info.id;
      this.startDate = info.startTime.substring(0, 16);
      this.endDate = info.endTime.substring(0, 16);
      this.initTime = { startDate: this.startDate, endDate: this.endDate };
      this.typeId = info.visitorTypeId;
      const oneType = this.typeList.filter(x => x.id == info.visitorTypeId);
      this.selectTypeShowTxt = oneType[0].typeName;
      this.isCoke = info.isCoke;
      const { trackingType } = this.typeList.find(x => x.id === this.typeId);
      this.isSpecialType = trackingType === 4;
      getEffectiveAreaList(this.typeId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.areaList = res.data.content.model;
          this.areaId = info.areaId;
          const modifyList = this.areaList.filter( (x) => x.id == info.areaId);
          this.isAreaDisabled = false;
          this.handleAreaChange(this.areaId, null, modifyList[0].areaName);
        }
      });
      this.areaDetail = info.visitAreaDetail;
      this.purposeDetail = info.visitReason;
      this.preferredLanguage = info.language;
      this.preferredLanguageValue = info.language == 1 ? this.$t('setLangCN') : this.$t('setLangEN');
      // bind data for primary visitor

      // bind data for selected course
      if (info.visitTicketLessonCategorys && info.visitTicketLessonCategorys.length) {
        this.isJoin = true;
        this.selectedCourse = info.visitTicketLessonCategorys.map(x => x.id);
        this.elLessonList.forEach((x) => {
          x.checked = this.selectedCourse.findIndex(id => id === x.id) !== -1;
        });
      }
      // bind data for all kinds of user list
      if (info.isCoke) {
        // place primary visitor to 1st
        const temp = [...info.visitTicketInviteVisitors.filter(x => x.isPrimaryVisitor), ...info.visitTicketInviteVisitors.filter(x => !x.isPrimaryVisitor)];
        this.innerList = temp.map(x => ({
          id: x.id, // TODO: add userId in API
          trackId: x.id,
          userName: x.userName,
          avatar: x.avatar,
          email: x.email,
          phoneNumber: x.phoneNumber,
          hasSubmitMaterials: x.hasSubmitMaterials,
        }));
      }
      if (info.visitTicketCCUsers) {
        this.copyList = info.visitTicketCCUsers.map(x => ({
          id: x.userId, trackId: x.id, avatar: x.avatar, deptName: x.deptName, userName: x.userName,
        }));
      }
      if (info.visitTicketOtherCheckers) {
        this.approvedList = info.visitTicketOtherCheckers.map(x => ({
          id: x.userId, trackId: x.id, avatar: x.avatar, deptName: x.deptName, userName: x.userName,
        }));
      }
    },
  },
  methods: {
    selectTypeShowHide() {
      if (this.inviteInfo && this.inviteInfo.hasMaterial) {
        this.selectTypeShow = false;
      } else {
        this.selectAreaShow = false;
        this.selectTypeShow = !this.selectTypeShow;
      } 
    },
    checkTypeisNull() {
      if (this.inviteInfo && this.inviteInfo.hasMaterial) {
        this.selectAreaShow = false;
      } else {
        this.selectTypeShow = false;
        this.typeId == -1 ? this.isSelectTipsModalShown = true : this.selectAreaShow = !this.selectAreaShow;
      }  
    },
    checkAreaisNull() {
      if (this.areaId == -1) {
        this.isSelectTipsModalShown = true;
      } else {
        this.selectAreaShow = false;
        this.selectTypeShow = false;
        this.selectBottlerShow = !this.selectBottlerShow;
      }
    },
    closeList() {
      this.$emit('getMessage', this.modalView);
    },
    closeModal() {
      if (this.addSucess === this.$t('SubmittedSuccessfully') || this.addSucess === this.$t('updatedSuccessfully')) {
        this.startDate = '';
        this.endDate = '';
        this.areaDetail = '';
        this.purposeDetail = '';
        this.primaryVisitor.userName = '';
        this.primaryVisitor.contact = '';
        this.primaryVisitor.bottlerId = '';
        this.selectedCourse = [];
        this.approvedList = [];
        this.copyList = [];
        this.isJoin = false;
        this.areaId = -1;
        this.typeId = -1;
        const id = this.DetailId;
        if (this.ticketId) {
          window.location.reload();
        } else {
          this.$router.push({ path: `/inviteDetail/${id}` });
        }
      } else if (this.ticketId) {
        window.location.reload();
      } else {
        this.isCommit = false;
        this.isConfirm = false;
      }
    },
    onScroll() {
      //console.log(this.$refs.content.scrollTop)
      if (this.$refs.content.scrollTop > 0) {
        setTimeout( () => {
          this.scrolled = true;
        }, 1)
      } else if(this.$refs.content.scrollTop == 0 ) {
        this.scrolled = false;
      }
       
    },
    hideContactSelect() {
      this.showContatSelect = false;
      this.primaryVisitor.contact = '';
      this.validContact = true;
    },
    checkContact() {
      if (this.primaryVisitor.pickedContact === this.$t('mobile')) {
        this.validContact = regExp.phone.test(this.primaryVisitor.contact);
      } else {
        this.validContact = regExp.email.test(this.primaryVisitor.contact);
      }
    },
    changeStatus(data) {
      if (data.type) {
        this.addKO = true;
        this.addKOType = data.type;
      } else {
        switch (this.addKOType) {
          case 'approved':
            data.forEach((x) => {
              if (this.approvedList.findIndex(y => y.id === x.id) === -1) {
                this.approvedList = [...this.approvedList, x];
              }
            });
            break;
          case 'copy':
            data.forEach((x) => {
              if (this.copyList.findIndex(y => y.id === x.id) === -1) {
                this.copyList = [...this.copyList, x];
              }
            });
            break;
          case 'inner':
            data.forEach((x) => {
              // userId is empty when edit, so check by contact
              if (this.innerList.findIndex(y => y.email === x.email || y.phoneNumber === x.phoneNumber) === -1) {
                this.innerList = [...this.innerList, x];
              }
            });
            break;
          default:
            break;
        }
        this.addKO = false;
      }
    },
    deleteKO(data) {
      switch (data.type) {
        case 'approved':
          this.approvedList = this.approvedList.filter(x => x.id !== data.id);
          break;
        case 'copy':
          this.copyList = this.copyList.filter(x => x.id !== data.id);
          break;
        case 'inner':
          const innerItem = this.innerList.find(x => x.id === data.id);
          this.innerList = this.innerList.filter(x => x.id !== data.id);
          this.visitorDetailList = this.visitorDetailList.filter(x => x.contact !== innerItem.email && x.contact !== innerItem.phoneNumber);
          break;
        default:
          break;
      }
    },
    handleDateChange() {
      const { startDate, endDate } = this;
      const date = new Date();
      let diff = 0;
      if (this.ticketId) {
        this.isTimeChanged = (startDate.substring(0, 16) !== this.initTime.startDate)
         || (endDate.substring(0, 16) !== this.initTime.endDate);
      }
      if (startDate) {
        const strArr = startDate.split(' ');
        //diff = Moment(new Date(`${strArr[0]}T${strArr[1]}:00`)) - Moment(date);
        diff = Moment(startDate) - Moment(date);
        if (diff < 0 && !this.inviteInfo) {
          this.errorMsgStartDate = true;
          this.errorStartDate = this.$t('entered');
        } else {
          this.errorMsgStartDate = false;
          this.errorStartDate = '';
        }
        if (endDate) {
          // check to see if endDate >= startDate
          diff = Moment(endDate) - Moment(startDate);
          if (diff <= 0) {
            this.errorMsgEndDate = true;
            this.errorEndDate = this.$t('endDateMustBeLater');
          } else {
            this.errorMsgEndDate = false;
            this.errorEndDate = '';
          }
        }
      }
    },
    checkName() {
      if (this.primaryVisitor.userName != '') {
        this.errorMsgName = false;
      } else {
        this.errorMsgName = true;
      }
    },
    checkDetail() {
      // only if special type or area this checking is needed
      this.errorMsgReason = (this.isSpecialType || this.isSpecialArea) && (!this.areaDetail || !this.purposeDetail);
    },
    handleTypeChange(id, name) {
      this.selectTypeShow = false;
      //const typeId = parseInt(event.target.value, 10);
      const typeId = id;
      if (this.typeList.findIndex(x => x.id === typeId) == -1) {
        this.areaList = [];
        this.isAreaDisabled = true;
        this.typeId = -1;

      } else {
        this.selectTypeShowTxt = name;
        this.isAreaDisabled = false;
        const { trackingType, isCoke } = this.typeList.find(x => x.id === typeId);
        this.isSpecialType = trackingType === 4;
        this.isCoke = isCoke;
        this.typeId = typeId;
        this.areaId = -1;
        this.selectAreaShowTxt = this.$t('SelectVisitArea');
        if (this.isSpecialType) {
          this.isJoin = false;
        }
        getEffectiveAreaList(typeId).then((res) => {
        // bind area list
          if (checkNested(res, 'data', 'content', 'model')) {
            this.areaList = res.data.content.model;
          }
        });
        this.visitorDetailList = []; // whenever area or type changed, empty added visitors
      }
    },
    handleAreaChange(id, oneId, name) {
      //const areaId = id !== null ? id : parseInt(event.target.value, 10);
      // console.log(event);
      const areaId = id !== null ? id : oneId;
      if (this.areaList.findIndex(x => x.id === areaId) !== -1) {
        this.selectAreaShowTxt = name;
        this.isSpecialArea = this.areaList.find(x => x.id === areaId).areaType === 2;
        this.areaId = areaId;
        this.visitorDetailList = []; // whenever area or type changed, empty added visitors
        // if (this.isSpecialArea) {
        //   this.isJoin = false;
        // }
        //get bottler message
        getBottlerPrimaryVisitors(this.typeId, this.areaId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            //console.log(res.data.content.model);
            this.bottlers = res.data.content.model;
          }
        })
        // get material options
        getMaterialOptions(this.areaId, this.typeId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            // console.log(res.data.content.model);
            materialsInstance = new Materials(res.data.content.model);
            this.materials = materialsInstance.init();
            this.hasMaterialsToFill = this.materials.length > 0;
            // use spread syntax to copy array of object
            this.currentMaterials = materialsInstance.init();
            this.primaryVisitor.materials = materialsInstance.init();
            // console.log(this.materials);

            // if edit invite info
            if (this.ticketId) {
              const info = this.$props.inviteInfo;
              const primaryVisitor = info.visitTicketInviteVisitors.find(x => x.isPrimaryVisitor);
              const primaryVisitorMaterialAnswered = primaryVisitor.visitTicketVisitorMaterials;
              this.primaryVisitor.id = primaryVisitor.id;
              this.primaryVisitor.contact = primaryVisitor.email || primaryVisitor.phoneNumber;
              this.primaryVisitor.pickedContact = primaryVisitor.email ? this.$t('email') : this.$t('mobile');
              this.primaryVisitor.userName = primaryVisitor.userName;
              this.errorMsgName = false;
              this.primaryVisitor.bottlerId = primaryVisitor.bottlerId;
              if (info.areaId == this.areaId && info.visitorTypeId == this.typeId) {
                if (this.bottlers.length) {
                  const getBottlerOne = this.bottlers.filter((x) =>  x.bottlerId == primaryVisitor.bottlerId);
                  if (getBottlerOne.length) {
                    getBottlerOne.forEach((x) =>  {
                      x.bottlerId === primaryVisitor.bottlerId ? this.selectBottlingShowTxt = x.bottlerName  : this.selectBottlingShowTxt = this.$t('chooseBottler');
                      x.bottlerId === primaryVisitor.bottlerId ? this.bottlerId = x.bottlerId  : this.bottlerId = -1;
                      this.bottlerRelevancePrimaryVisitors = x.primaryVisitors;
                    });
                  } else {
                    this.selectBottlingShowTxt = primaryVisitor.bottlerName ? primaryVisitor.bottlerName : this.$t('chooseBottler');
                    this.bottlerRelevancePrimaryVisitors = [];
                    this.bottlerId = primaryVisitor.bottlerId ? primaryVisitor.bottlerId : -1;
                  }
                } else {
                   this.bottlerId = -1;
                }
              } else {
                this.bottlerId = -1;
                this.selectBottlingShowTxt = this.$t('chooseBottler');
                this.primaryVisitor.userName = '';
                this.primaryVisitor.contact = '';
              }
              const temp = this.isCoke ?
                [...info.visitTicketInviteVisitors.filter(x => x.isPrimaryVisitor), ...info.visitTicketInviteVisitors.filter(x => !x.isPrimaryVisitor)]
                : info.visitTicketInviteVisitors.filter(x => !x.isPrimaryVisitor);
              this.visitorDetailList = temp.map(x => ({
                id: x.id, // trackId !== 0
                userName: x.userName,
                contact: x.email || x.phoneNumber,
                pickedContact: x.email ? this.$t('email') : this.$t('mobile'),
                isPrimaryVisitor: x.isPrimaryVisitor,
                materials: x.visitTicketVisitorMaterials,
                hasSubmitMaterials: x.hasSubmitMaterials,
              }));

              this.visitorDetailList.forEach((v) => {
                v.materials = materialsInstance.fillInitMaterialsWithAnswers(v.materials);
              });

              this.primaryVisitor.materials = materialsInstance.fillInitMaterialsWithAnswers(primaryVisitorMaterialAnswered);
              this.primaryVisitor.hasSubmitMaterials = primaryVisitor.hasSubmitMaterials;
              this.showPrimaryVisitorExtraField = this.currentMaterials.length > 0;
            } else {
              this.bottlerId = -1;
              this.selectBottlingShowTxt = this.$t('chooseBottler');
              this.primaryVisitor.userName = '';
              this.primaryVisitor.contact = '';
            }
          }
        });
      } else {
        this.areaId = -1;
      }
    },
    handleBottlerChange(id, oneId, name) {
      const BottlerId = id !== null ? id : oneId;
      if (this.bottlers.findIndex(x => x.bottlerId === BottlerId) !== -1) {
        this.selectBottlingShowTxt = name;
        this.bottlerId = BottlerId;
        const newPrimaryVisitor = this.bottlers.filter((x) => x.bottlerId == BottlerId  ? x.primaryVisitors : '');
        const primaryVisitor = newPrimaryVisitor[0];
        //console.log(primaryVisitor.primaryVisitors)
        if (primaryVisitor.primaryVisitors.length == 1) {
          this.bottlerRelevancePrimaryVisitors = primaryVisitor.primaryVisitors;
          this.handleAddKOPrimaryUser(primaryVisitor.primaryVisitors[0]);
        } else {
          this.primaryVisitor.userName = '';
          this.bottlerRelevancePrimaryVisitors = primaryVisitor.primaryVisitors;
        }
      }
    },
    handleCourseSelect(event) {
      const { checked } = event.target;
      const idStr = event.target.id.split('el-')[1];
      const id = parseInt(idStr, 10);
      let index = 0;
      if (checked) {
        index = this.selectedCourse.findIndex(x => x === id);
        this.selectedCourse = index === -1 ? [...this.selectedCourse, id] : this.selectedCourse;
      } else {
        this.selectedCourse = this.selectedCourse.filter(x => x !== id);
      }
      // sync checked attr with elLessonList arr
      this.elLessonList = this.elLessonList.map((x) => {
        x.checked = id === x.id ? checked : x.checked;
        return x;
      });
    },
    handleJoinCourse(event) {
      this.isJoin = event.target.checked;
      this.elLessonList.forEach((x) => {
        x.checked = false;
      });
      this.selectedCourse = [];
    },
    checkData() {
      this.errorMsgStartDate = this.errorMsgStartDate || !this.startDate;
      this.errorStartDate = !this.startDate ? this.$t('pleaseChooseStartDate') : this.errorStartDate;
      this.errorMsgEndDate = this.errorMsgEndDate || !this.endDate;
      this.errorEndDate = !this.endDate ? this.$t('pleaseChooseEndDate') : this.errorEndDate;
      this.errorMsgTypeSelect = this.typeId === -1;
      this.errorMsgAreaSelect = this.areaId === -1;
      this.errorMsgLesson = this.isJoin && !this.selectedCourse.length;
      this.errorMsgReason = (this.isSpecialType || this.isSpecialArea) && (!this.areaDetail || !this.purposeDetail);
      this.errorMsgName = !this.primaryVisitor.userName && !this.isCoke;
      this.errorMsgInnerVisitor = this.isCoke && !this.innerList.length;
      //console.log(this.errorMsgName)
     // console.log(this.primaryVisitor.userName)
      if (!this.isCoke) {
        this.checkContact();
      }

      if (!this.errorMsgStartDate && !this.errorMsgEndDate && !this.errorMsgReason && !this.errorMsgName && this.validContact
       && !this.errorMsgTypeSelect && !this.errorMsgAreaSelect && !this.errorMsgLesson && !this.errorMsgInnerVisitor) {
        this.isCommit = true;
      }

      // extra check: if user hit submit directly for primary visitor
      let { materials } = this.primaryVisitor;
      materials.forEach((x) => {
        x.skipCheck = Materials.checkIfNeedToSkip(x, materials);
      });
      materials = Materials.checkIsRequiredFinished(materials);
      if (materials.findIndex(m => m.isError) !== -1) {
        this.showPrimaryVisitorExtraField = true;
        this.isCommit = false;
      }

      // scroll to error msg label
      if (!this.isCommit) {
        scrollErrMsgToView('.newInvisitContent');
      }
    },
    commitData() {
      if (!this.errorMsgStartDate && !this.errorMsgEndDate && !this.errorMsgReason && !this.errorMsgName && this.validContact && !this.errorMsgTypeSelect && !this.errorMsgAreaSelect) {
        const visitTicketInviteVisitors = [];

        const visitTicketLessonCategorys = this.selectedCourse.map(courseId => ({
          id: courseId,
        }));

        const visitTicketOtherCheckers = this.approvedList.map(x => ({
          id: x.trackId,
          userId: x.id,
        }));

        const visitTicketCCusers = this.copyList.map(x => ({
          id: x.trackId,
          userId: x.id,
        }));

        // const visitTicketInviteKOUser = this.innerList.map(x => ({
        //   id: x.trackId,
        //   userId: x.id,
        // }));

        this.visitorDetailList.forEach((x) => {
          x.materials = x.materials.filter(m => this.isCoke || !m.isCompany);
        });

        const { isCoke } = this;
        const temp = !isCoke ? [this.primaryVisitor, ...this.visitorDetailList] : this.innerList;
        
        temp.forEach((x, idx) => {
          const user = {};
          let postMaterials = [];
          user.userName = x.userName;
          user.id = !isCoke ? x.id : (this.inviteInfo ? x.trackId : 0); // trackId
          user.isPrimaryVisitor = isCoke ? idx === 0 : x.isPrimaryVisitor;
          this.bottlers.length ? (user.isPrimaryVisitor === x.isPrimaryVisitor ? user.bottlerId = this.bottlerId : user.bottlerId = -1) : user.bottlerId = -1;
          user.bottlerId = user.isPrimaryVisitor === x.isPrimaryVisitor && user.bottlerId == -1 ? x.bottlerId : user.bottlerId;
          user.isPrimaryVisitor === false  ? user.bottlerId = -1 : user.bottlerId;
          if (isCoke) {
            user.email = x.email;
            user.phoneNumber = x.email ? '' : x.phoneNumber;
            const visitorDetail = this.visitorDetailList.find(v => (v.contact === x.email || v.contact === x.phoneNumber));
            //console.log(visitorDetail);
            if (visitorDetail) {
              x.materials = idx !== 0 ? visitorDetail.materials.filter(m => !m.isCompany) : visitorDetail.materials;
              x.hasSubmitMaterials = visitorDetail.hasSubmitMaterials;
            } else {
              x.materials = [];
              x.hasSubmitMaterials = x.hasSubmitMaterials || false; // if has previous value true
            }
          } else if (x.pickedContact === this.$t('mobile')) {
            user.phoneNumber = x.contact;
            user.email = '';
          } else {
            user.email = x.contact;
            user.phoneNumber = '';
          }
          x.materials.forEach((m) => {
            m.skipCheck = Materials.checkIfNeedToSkip(m, x.materials);
          });
          //console.log(x.materials)
          postMaterials = Materials.checkIsRequiredFinishedBeforePost(x.materials);
          //console.log(postMaterials)
          if (postMaterials.length) {
            postMaterials = x.materials.filter(m => (typeof m.answer === 'string' ? m.answer : (m.answer !== null && m.answer.length)) && !m.skipCheck);
          }
          
          //console.log(postMaterials);
          user.visitTicketVisitorMaterials = postMaterials.map(y => ({
            id: y.trackId,
            materialOptionId: y.id,
            answer: Materials.handleAnswerForPost(y),
          }));
          user.hasSubmitMaterials = x.hasSubmitMaterials;
          visitTicketInviteVisitors.push(user);
        });

        // if (this.isCoke && !this.visitorDetailList.length) {
        //   visitTicketInviteVisitors = this.innerList.map((x, idx) => ({
        //     id: x.id,
        //     userName: x.userName,
        //     phoneNumber: x.phoneNumber,
        //     email: x.email,
        //     isPrimaryVisitor: idx === 0,
        //     hasSubmitMaterials: x.hasSubmitMaterials || false,
        //   }));
        // }
        //console.log(temp)
        //console.log(visitTicketInviteVisitors)
        const filterVisitorName = [];
        visitTicketInviteVisitors.forEach((x) => {
          x.id !== 0 && x.visitTicketVisitorMaterials.length == 0 && !x.isPrimaryVisitor ? filterVisitorName.push(x.userName) : '';
          return  filterVisitorName;
        })
        const newfilterVisitorName = filterVisitorName.join(',');
       // if (filterVisitorName.length == 0) {
          const postData = {
            id: this.ticketId,
            areaId: this.areaId,
            visitorTypeId: this.typeId,
            startTime: this.startDate,
            endTime: this.endDate,
            visitAreaDetail: this.areaDetail,
            visitReason: this.purposeDetail,
            language: this.preferredLanguage,
            visitTicketLessonCategorys,
            visitTicketOtherCheckers,
            visitTicketCCusers,
            visitTicketInviteVisitors,
            // visitTicketInviteKOUser,
          };
          const insertOrUpdateInviteModel = postData;
          // console.log(JSON.stringify(postData));
          // console.log(postData);
          this.isLoading = true;
          this.isCommit = false;
          InsertOrUpdate(insertOrUpdateInviteModel).then((res) => {
            if (res.data.content.status === 1) {
              this.DetailId = res.data.content.model.id;
              this.addSucess = this.ticketId ? this.$t('updatedSuccessfully') : this.$t('SubmittedSuccessfully');
            } else {
              this.addSucess = res.data.content.message;
            }
            this.isConfirm = true;
            this.isLoading = false;
          });
        // } else {
        //   this.isCommit = false;
        //   this.isRequireModal = true;
        //   this.isRequireModalTips = this.$t('visitorName') + newfilterVisitorName + this.$t('needIncompleteMaterial');
        // }
        
      }
    },

    handleTogglePrimaryVisitorExtraField() {
      this.showPrimaryVisitorExtraField = !this.showPrimaryVisitorExtraField;
    },

    // visitor detail
    initMaterialAnswer(m) {
      if (m.materialType === 2) { // checkbox
        m.answer = [];
      }
      if (m.materialType === 8) {
        const optionArr = JSON.parse(m.materialAnswerTemplate);
        [, m.answer] = optionArr; // array destructuring syntax, same as m.answer = optionArr[1]
      }
      if (m.preQuestionId !== -1) {
        // make preQuestion's 'false' answer checked by default
        const preQuestion = this.materials.find(y => y.id === m.preQuestionId);
        const preQuestionAnswerArr = JSON.parse(preQuestion.materialAnswerTemplate);
        const idx = JSON.parse(m.preQuestionAnswer)[0];
        const actualPreQuestionAnswer = preQuestionAnswerArr[idx];
        // [, preQuestion.answer] = preQuestionAnswerArr;
        m.preQuestionAnswer = actualPreQuestionAnswer;
      }
    },
    handleAddOrEditVisitorDetail(data) {
      this.showVisitorDetail = true;
      if (typeof data === 'number') {
         //console.log(this.visitorDetailList);
        this.currentVisitor = Object.assign({}, this.visitorDetailList[data]);
        //console.log(this.currentVisitor);
        this.currentMaterials = this.materials.map(m => ({ ...m }));
        this.currentVisitor.materials.forEach((m) => {
          const currentM = this.currentMaterials.find(x => x.id === m.id);
          currentM.answer = m.answer;
          currentM.trackId = m.trackId;
          if (m.names) {
            currentM.names = m.names;
          }
        });
        this.isAdd = false;
        this.idx = data;
      } else {
        this.isAdd = true;
        this.idx = -1;
        // this is new add
        // this.handleClearCurrent(false); // here used to reset file input
        this.currentVisitor = {
          id: 0,
          userName: '',
          pickedContact: this.$t('mobile'),
          contact: '',
          isPrimaryVisitor: false,
          materials: [],
          hasSubmitMaterials: false,
        };
        this.currentMaterials = this.materials.map(m => ({ ...m }));
      }
    },
    handleAnswer(data) {
      // sync with this.currentMaterials
      const materials = data.isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials;
      Materials.handleAnswer(data, materials);
    },
    handleDeleteImg(data) {
      const materials = data.isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials;
      Materials.handleDeleteImgOrAnnex(data, materials);
    },
    handleDeleteAnnex(data) {
      const materials = data.isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials;
      Materials.handleDeleteImgOrAnnex(data, materials);
    },
    handleSaveCurrent(data) {
      let flag = true;
      let materials = data.isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials.filter(m => this.isCoke ||  !m.isCompany);
      materials.forEach((x) => {
        x.skipCheck = Materials.checkIfNeedToSkip(x, materials);
      });
      materials = Materials.checkIsRequiredFinished(materials);
      flag = materials.findIndex(m => m.isError) === -1;
      if (data.isPrimaryVisitor) {
        this.showPrimaryVisitorExtraField = !flag;
      } else {
        // console.log(`flag: ${flag}`);
        if (flag) {
          this.currentVisitor.materials = this.currentMaterials.filter(x => !x.skipCheck && (this.isCoke || !x.isCompany)).map(m => ({ ...m }));
          if (this.isAdd) {
            this.visitorDetailList = [...this.visitorDetailList, this.currentVisitor];
          } else {
            this.visitorDetailList = this.visitorDetailList.map((x, idx) => (idx === this.idx ? this.currentVisitor : x));
          }
          this.showVisitorDetail = false;
          this.showOtherVisitor = true;
        }
      }
    },
    handleClearCurrent(isPrimaryVisitor) {
      // this.currentVisitor.userName = '';
      // this.currentVisitor.contact = '';
      const materials = isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials;
      let id = '';
      if (isPrimaryVisitor) {
        // this.primaryVisitor.userName = '';
        // this.primaryVisitor.contact = '';
        materials.forEach((x) => {
          switch (x.materialType) {
            case 2:
              x.answer = [];
              break;
            case 6:
              x.answer = [];
              x.names = [];
              id = `${x.id}-${isPrimaryVisitor ? 'primary' : 'other'}`;
              document.getElementById(id).value = null;
              break;
            case 7:
            case 9:
              x.answer = [];
              id = `${x.id}-${isPrimaryVisitor ? 'primary' : 'other'}`;
              document.getElementById(id).value = null;
              break;
            default:
              x.answer = [];
              break;
          }
        });
      } else {
        this.isDeleteModalShow = true;
      }
    },
    deleteVisitor() {
      this.visitorDetailList = this.visitorDetailList.filter((x, index) => index !== this.idx);
      this.isDeleteModalShow = false;
      this.showVisitorDetail = false;
    },
    bindHistoryData(model, isPrimaryVisitor) {
      const materials = isPrimaryVisitor ? this.primaryVisitor.materials : this.currentMaterials;
      Materials.bindHistoryMaterialsData(model, materials);
    },
    handleLoadHistory(isPrimaryVisitor) {
      const targetVisitor = isPrimaryVisitor ? this.primaryVisitor : this.currentVisitor;
      const phone = targetVisitor.pickedContact === this.$t('mobile') ? targetVisitor.contact : '';
      const email = targetVisitor.pickedContact === this.$t('email') ? targetVisitor.contact : '';
      if (phone || email) {
        this.isLoading = true;
        loadHistroyMaterialAnswers(phone, email).then((res) => {
          this.isLoading = false;
          if (checkNested(res, 'data', 'content', 'model')) {
            this.bindHistoryData(res.data.content.model, isPrimaryVisitor);
          }
        });
      }
    },
    handleLoadCompanyHistory(data) {
      if (data.companyName) {
        loadHistroyCompanyMaterialAnswers(data.companyName).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            this.bindHistoryData(res.data.content.model, data.isPrimaryVisitor);
          }
        });
      }
    },
    handleAddKOUser(user) {
      if (user) {
        const { userName, email, phoneNumber } = user;
        this.currentVisitor.userName = userName;
        this.currentVisitor.contact = email || phoneNumber;
        this.currentVisitor.pickedContact = email ? this.$t('email') : this.$t('mobile');
      }
    },
    handleAddKOPrimaryUser(user) {
      if (user) {
        //console.log('得到到的user')
        //console.log(user)
        const { userName, account, accountType } = user;
        this.primaryVisitor.userName = userName;
        this.primaryVisitor.contact = account;
        this.primaryVisitor.pickedContact = accountType == 2 ? this.$t('email') : this.$t('mobile');
      }
    },
    changeLanguage(id, value) {
      this.languageShow = false;
      this.preferredLanguageValue = value;
      this.preferredLanguage = id;
    },
    checkIfCanAddKO(event) {
      //console.log(this.bottlerRelevancePrimaryVisitors.length)
      if (this.bottlerRelevancePrimaryVisitors.length && this.bottlerId !== -1) {
        this.isAddPrimary = true;
        this.isPrimaryVisitorAlertShow = false;
        event.currentTarget.blur();
      } else if (this.bottlerId !== -1 && this.bottlerRelevancePrimaryVisitors.length == 0) {
        event.currentTarget.blur();
        this.isAddPrimary = false;
        this.noPrimaryVisitorAlertShow = true;
      } else {
        event.currentTarget.blur();
        this.isAddPrimary = false;
        this.isPrimaryVisitorAlertShow = true;
      }
    },
     // some special logic for add ko  visitor
    handleSelectKO(data) {
      this.isAddPrimary = false;
      //this.$emit('addKOUser', data[0]);

      this.handleAddKOPrimaryUser(data[0]);
    },
  },
};
</script>

<style lang="scss">
.new-invite-title {
  font-weight: bold;
  font-size: 14px;
  .icon-add {
    color: #e42029;
    font-size: 18px;
    margin-right: 10px;
    font-weight: normal;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }
  .content-remarks {
    font-weight: normal;
    font-size: 12px;
    color: #929292;
  }
}
.invisitArea {
  select.un-selected {
    color: #929292 !important;
  }
}
</style>
<style scoped lang="scss">
  @import '../scss/variables.scss';
  .newInvisitContent {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    width: 100%;
    position: absolute;
    bottom: 0;
    overflow: hidden;
    & > div:first-child {
      padding: 20px 5% 5px;
      font-size: 18px;
      color: #4a4a4a;
      line-height: 1;
      font-weight: bold;
      i {
        float: right;
        font-size: 22px;
        font-weight: normal;
      }
    }
    .new-invisit-content {
      width: 100%;
      height: 100vh;
      overflow-x: hidden;
      overflow-y: auto;
      padding-top: 80px;
      & > div:first-child {
        width: 84.5%;
        margin: auto;
      }
      .main-invisit {
        width: 100%;
        margin: 0 auto;
        padding: 0 12px;
        margin-bottom: 15px;
        background-color: #fff;
        border-radius: 4px;
        & > div:first-child {
          padding: 20px 0;
          font-size: 14px;
          color: #4a4a4a;
        }
        & > div:last-child {
          div.row {
            margin: 0;
            padding-top: 17px;
            &:first-child {
              padding-top: 0;
              border-bottom: 1px solid #f0f1f2;
            }
            & + .row {
              border-top: 1px solid #f0f1f2;
            }
            &.form-error {
              border-bottom: 1px solid #e42029;
            }
            div {
              padding: 0 0 16px;
              font-size: 13px;
              color: #4a4a4a;
              &:last-child {
                text-align: right;
              }
              input {
                color: #4a4a4a;
                text-align: right;
                border: none;
                outline: none;
                width: 100%;
              }
            }
          }
          .control-label {
            margin: 0;
            display: block;
            border-right: 1px solid #f0f1f2;
            i {
              font-size: 12px;
              padding-left: 2.5vw;
              display: inline-block;
              transform: scale(0.75,0.75);
            }
          }
          .contact-select {
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: rgba(0,0,0,.4);
            z-index: 99;
            .inner {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              border-radius: 10px 10px 0 0;
              padding-bottom: 0;
              overflow: hidden;
              background: #f2f2f2;
            }
            .form-group {
              padding: 0;
              width: 90%;
              margin: 0 auto;
              & + .form-group {
                border-top: 1px solid #ddd;
              }
            }
            input {
              display: none;
              &:checked + label {
                color: #e42029;
              }
            }
            label {
              margin-bottom: 0;
              padding: 13px;
              font-size: 20px;
              text-align: center;
              display: block;
            }
          }
        }
      }
      .invisitMessage {
        width: 100%;
        margin: 0 auto;
        padding: 0 12px;
        background-color: #fff;
        border-radius: 4px;
        & > div:first-child {
          padding: 20px 0;
          font-size: 14px;
          color: #4a4a4a;
        }
        & > div:last-child {
          .typeList {
            position: relative;
            color: #4a4a4a;
            cursor: pointer;
            & > div {
              span {
                color: #4a4a4a !important;
                margin-right: 5px;
                width: 70%;
                display: inline-block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: middle;
              }
              i {
                 vertical-align: middle;
              }
            }
            div {
              input {
                cursor: pointer;
                text-align: right !important;
                margin-right: 5px;
                color: #4a4a4a;
                width: 70% !important;
                &:disabled {
                  background: #fff;
                }
              }
            }
            ul {
              position: absolute;
              right: 10px;
              top: 25px;
              width: 60%;
              text-align: left;
              border: 1px solid #929292;
              background: #fff;
              z-index: 20;
              overflow: auto;
              max-height: 240px;
              @include respond-to('sm-max') {
                width: 70%;
              }
              li {
                list-style: none;
                cursor: pointer;
                padding: 5px 8px;
                &:hover {
                  background: #0074e8;
                  color: #fff;
                }
              }
            }
          }
          .areaList {
            input {
              cursor: pointer;
              &:disabled {
                background: #fff;
              }
              width: 70% !important;
            }
          }
          div.row {
            margin: 0;
            padding: 15px 0;
            border-bottom: 1px solid #f0f1f2;
            &:first-child {
              padding-top: 0;
              &.form-error {
                border-bottom: 1px solid red;
              }
            }
            &.form-error {
              border-bottom: 1px solid red;
            }
            div {
              &:last-child {
                text-align: right;
              }
              padding: 0;
              font-size: 13px;
              color: #4a4a4a;
              span {
                color: #e42029;
              }
              input {
                width: 85px;
                border: none;
                outline: none;
                text-align: center;
              }
            }
            .invisitTime {
              label {
                margin-bottom: 0;
                position: absolute;
                right: 20px;
                font-size: 13px;
              }
            }
            .invisitArea {
              select {
                -webkit-appearance: none;
                border: none;
                background: url('../assets/images/arrow-copy.png') no-repeat right;
                background-size: 8px;
                padding-right: 20px;
                color: #4a4a4a;
                text-align: right;
              }
            }
          }
          .add-more {
            border-top: 1px solid #f0f1f2;
            .add-more-btn {
              padding: 16px 0;
              font-size: 14px;
              color: #4a4a4a;
              img {
                width: 20px;
                height: 23px;
                margin-right: 10px;
              }
            }
          }
        }
      }
      .add-detail-info {
        padding: 0 12px;
        & > div:first-child {
          padding: 20px 0;
          .optional {
            color: #929292;
            font-weight: normal;
          }
        }
        .detail {
          & > div:first-child,
          & > div:nth-of-type(2) {
            width: 100%;
            padding-bottom: 15px;
            div:first-child {
              font-size: 13px;
              color: #4a4a4a;
              padding-bottom: 12px;
            }
            textarea {
              width: 100%;
              background-color: #f0f0f0;
              font-size: 13px;
              color: #4a4a4a;
              border: 0;
              padding: 5px 10px;
            }
          }
        }
      }
      .selectCourse-detail {
        margin-top: 16px;
      }
      .select-language {
        width: 100%;
        margin: 0 auto;
        padding: 12px;
        margin-bottom: 15px;
        background-color: #fff;
        border-radius: 4px;
        .down-language {
          position: relative;
          text-align: right;
          & > div {
            cursor: pointer;
            span {
              color: #4a4a4a;
              font-size: 13px;
              margin-right: 5px;
            }
          }
          input {
            width: 66px;
            margin-right: 10px;
            font-size: 13px;
            color: #4a4a4a;
            text-align: right;
            margin-right: 5px;
            cursor: pointer;
          }
          ul {
            position: absolute;
            top: 25px;
            right: 10px;
            background: #fff;
            border: 1px solid #929292;
            width: 110px;
            text-align: left;
            li {
              &:hover {
                background: #0074e8;
                color: #fff;
              }
              list-style: none;
              line-height: 24px;
              color: #4a4a4a;
              font-size: 14px;
              cursor: pointer;
            }
          }
        }
        & > div {
          select {
            width: 100%;
            -webkit-appearance: none;
            border: none;
            background: url('../assets/images/arrow-copy.png') no-repeat right;
            background-size: 8px;
            padding-right: 20px;
            font-size: 13px;
            color: #4a4a4a;
            text-align: right;
          }
        }
      }
      .commit-btn {
        width: 100%;
        height: 46px;
        line-height: 46px;
        text-align: center;
        border-radius: 5px;
        margin-top: 40px;
        margin-bottom: 40px;
        background-image: linear-gradient(81deg, #f36443, #e42029);
        span {
          font-size: 15px;
          font-weight: 600;
          color: #fff;
        }
      }
      .detail-list-show-up {
        padding: 12px;
        & > div.row {
          margin: auto;
          .title {
            color: #4a4a4a;
            font-size: 14px;
            padding-left: 20px;
            font-weight: bold;
            line-height: 24px;
            background: url('../assets/images/user-copy@3x.png') no-repeat center left;
            background-size: 17px auto;
          }
          .col-3 {
            padding: 0;
            text-align: right;
            cursor: pointer;
            i {
              font-size: 12px;
              padding-left: 2.5vw;
              display: inline-block;
              -webkit-transform: scale(0.75, 0.75);
              transform: scale(0.75, 0.75);
            }
          }
        }
      }
      .new-invite-row {
        margin-bottom: 15px;
        border-radius: 4px;
        background: #fff;
        //overflow: hidden;
        box-shadow: 0 0 25px rgba(100,100,100,.15);
        &.visitor-detail-list-row {
          margin-bottom: 15px;
        }
      }
      .add-more-btn {
        i {
          font-size: 18px;
          margin-right: 5px;
          color: #e42029;
        }
        span {
          font-weight: bold;
        }
      }
      .bottlingBox {
        .bottlingSelect {
          margin: 0;
          padding: 0;
          border-bottom: 1px solid #f0f1f2;
          padding-bottom: 15px;
          div {
            font-size: 13px;
            color: #4a4a4a;
            padding: 0;
            cursor: pointer;
          }
          div:last-child {
            text-align: right;
            div {
              span {
                color: #4a4a4a !important;
                margin-right: 5px;
                width: 85%;
                display: inline-block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: middle;
              }
              i {
                vertical-align: middle;
              }
            } 
          }
          .invisitBottling {
            ul {
              position: absolute;
              right: 10px;
              top: 25px;
              max-width: 80%;
              text-align: left;
              border: 1px solid #929292;
              background: #fff;
              z-index: 20;
              overflow: auto;
              max-height: 240px;
              li {
                list-style: none;
                cursor: pointer;
                padding: 5px 8px;
                &:hover {
                  background: #0074e8;
                  color: #fff;
                }
              }
            }
          }
        }
        .name-select {
          padding: 15px 0;
          margin: 0;
          &.form-error {
            border-bottom: 1px solid red;
          }
          div {
            font-size: 13px;
            color: #4a4a4a;
            padding: 0;
          }
          div:last-child {
            text-align: right;
            padding-right: 0;
            cursor: pointer;
            input {
              width: 90%;
              text-align: right;
              color: #4a4a4a;
              border: none;
              outline: none
            }
            .select-ko {
              // background: url('../assets/images/arrow-copy.png') no-repeat right;
              // background-size: 8px;
              padding-right: 5px;
            }
          }
        }
      }
    }
    &.scrolled {
      border-radius: 0;
      top: 0;
      & > div:first-child {
        padding-bottom: 20px;
        box-shadow: 0 0 15px rgba(100,100,100,.2);
        position: fixed;
        width: 100%;
        background: #fff;
        z-index: 20;
      }
      // .new-invisit-content {
      //   height: 100vh;
      //   padding-top: 60px;
      // }
    }
    .error-msg {
      color: #e42029;
      font-size: 11px;
      text-align: right;
      width: 100%;
      &.right-padding {
        padding-right: 12px;
      }
    }
  }
</style>
